import { useState } from 'react';
import { Icon } from './Icon';
import { Picture } from './Picture';

/** Before/after comparison. A transparent native range input drives it (keyboard + touch accessible). */
export function BeforeAfter() {
  const [pos, setPos] = useState(50);
  return (
    <div className="relative w-full max-w-5xl mx-auto h-[380px] sm:h-[480px] md:h-[580px] rounded-xl overflow-hidden shadow-2xl select-none group">
      <div className="absolute inset-0 bg-surface-container">
        <Picture
          name="home-after-living-room"
          alt="Finished living room after the Green Valley transformation, with cove lighting, a travertine table and emerald velvet chairs"
          sizes="(min-width: 1024px) 1024px, 100vw"
          className="block w-full h-full"
          imgClassName="w-full h-full object-cover"
        />
        <div className="absolute top-4 right-4 md:top-6 md:right-6 px-3 md:px-4 py-1.5 rounded bg-primary/80 backdrop-blur-md text-gold-light font-label-md text-label-md uppercase tracking-widest">
          Transformed Living Space
        </div>
      </div>
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <Picture
          name="home-before-concrete"
          alt="The same room before the transformation: bare concrete walls, exposed wiring and unfinished floors"
          sizes="(min-width: 1024px) 1024px, 100vw"
          className="block w-full h-full"
          imgClassName="w-full h-full object-cover"
        />
        <div className="absolute top-4 left-4 md:top-6 md:left-6 px-3 md:px-4 py-1.5 rounded bg-botanical-dark/85 backdrop-blur-md text-surface-ivory font-label-md text-label-md uppercase tracking-widest">
          Raw Architectural Canvas
        </div>
      </div>
      <div
        className="absolute top-0 bottom-0 -ml-0.5 w-1 bg-gold-light flex items-center justify-center shadow-[0_0_15px_rgba(0,0,0,0.5)] pointer-events-none"
        style={{ left: `${pos}%` }}
      >
        <div className="w-10 h-10 rounded-full bg-primary text-gold-light border-2 border-gold-light flex items-center justify-center shadow-lg transition-transform group-hover:scale-110">
          <Icon name="swap_horiz" size={20} />
        </div>
      </div>
      <input
        type="range"
        min={0}
        max={100}
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Reveal before and after: drag left to see the finished room, right to see the raw structure"
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize z-30"
      />
    </div>
  );
}
